<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      no-local-sorting
      sort-icon-left
    >
      <template
        v-if="listFilters"
        #top-row="data"
      >
        <td
          v-for="(field,key) in data.fields"
          :key="key"
        >
          <list-column-filter
            v-if="field.key !=='action'"
            :name="field.key"
            :label="field.label"
            :filter="listFilters[field.key]"
            :value="filters[field.key]"
            @onFilterChange="( name, value)=> $emit('onFilterChange', name, value)"
          />
          <b-button
            v-else
            block
            variant="success"
            @click="$emit('onFilterButtonClicked')"
          >
            {{ $t("Search") }}
          </b-button>
        </td>
      </template>
      <!-- A custom formatted user column -->
      <template #cell(user)="data">
        <display-user :user="data.value" />
      </template>
      <!-- A custom formatted type column -->
      <template #cell(type)="data">
        <display-status
          :value="data.value"
          :text="data.item.display_type"
        />
      </template>
      <!-- A custom formatted status column -->
      <template #cell(status)="data">
        <display-status
          :value="data.value"
          :text="data.item.display_status"
        />
      </template>
      <!-- A custom formatted server_status column -->
      <template #cell(server_status)="data">
        <display-status
          :value="data.value"
          :text="data.item.display_server_status"
        />
      </template>
      <!-- A custom formatted restart_at column -->
      <template #cell(restart_at)="data">
        <display-date-time
          :value="data.value"
        />
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <b-button
          v-if="$can('read', 'accounts')"
          variant="flat-info"
          size="sm"
          class="btn-icon rounded-circle"
          @click="$router.push({name:'accounts-show',params:{id:data.item.id}})"
        >
          <feather-icon icon="EyeIcon" />
        </b-button>
        <b-button
          v-if="$can('update', 'accounts') && data.item.screenshot"
          variant="flat-secondary"
          size="sm"
          class="btn-icon rounded-circle"
          @click="$emit('onScreenshotButtonClicked',data.item)"
        >
          <feather-icon icon="CameraIcon" />
        </b-button>
        <b-button
          v-if="$can('update', 'accounts')"
          variant="flat-danger"
          size="sm"
          class="btn-icon rounded-circle"
          @click="$emit('onDeleteSessionClicked',data.item)"
        >
          <feather-icon icon="AlertTriangleIcon" />
        </b-button>
        <b-button
          v-if="$can('update', 'accounts')"
          variant="flat-primary"
          size="sm"
          class="btn-icon rounded-circle"
          @click="$emit('onSendAccountConnectMessageClicked',data.item)"
        >
          <feather-icon icon="MessageSquareIcon" />
        </b-button>
        <b-button
          v-if="$can('update', 'accounts')"
          variant="flat-success"
          size="sm"
          class="btn-icon rounded-circle"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
        <b-button
          v-if="$can('update', 'accounts')"
          variant="flat-warning"
          size="sm"
          class="btn-icon rounded-circle"
          @click="$emit('onRestartButtonClicked',data.item)"
        >
          <feather-icon icon="RefreshCwIcon" />
        </b-button>
        <b-button
          v-if="data.item.deleteAble || $can('delete', 'accounts')"
          variant="flat-danger"
          size="sm"
          class="btn-icon rounded-circle"
          @click="deleteButtonClicked(data.item)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no accounts to display") }}
      </h6>
    </div>
    <accounts-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
    />
  </div>
</template>

<script>
import { ListTable } from '../../../common/mixins/list'
import AccountsEditModal from '../edit/AccountsEditModal'

export default {
  name: 'AccountsList',
  components: { AccountsEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'accounts',
    }
  },
}
</script>

<style scoped>

</style>
